import * as yup from "yup";

const createPromoCodeValidator = yup
  .object({
    name: yup.string().required("Name is required"),
    amount: yup
      .number()
      .typeError("Amount should be number")
      .required("Amount is required"),
    quantity: yup
      .number()
      .typeError("Amount should be number")
      .required("Quantity is required"),
  })
  .required();

export default createPromoCodeValidator;
